@if (data.length) {
    <div class="simpleTooltip" [style.--text-width]="tooltipTextWidthCharacters + 'ch'">
        @if (showHtmlContent) {
            @for (tooltip of data; track tooltip) {
                <div class="tooltipText" [innerHTML]="tooltip"></div>
            }
        } @else {
            @for (tooltip of data; track tooltip) {
                <div class="tooltipText">{{ tooltip | translate }}</div>
            }
        }
    </div>
}
